// extracted by mini-css-extract-plugin
export default {"PostAdmin":"Blog_PostAdmin__DmuWq","BookBtn":"Blog_BookBtn__iuCeL"};